import axios from '@/api/config/request'
import { BASE_API } from './index'

// 企业信息校验（校验是否已存在）
export function checkCompanyByName(name) {
  return axios({
    url: `${BASE_API}/company/check?name=${name}`,
    method: 'get'
  })
}

/**
 * 获取最新一次企业认证提交信息
 * @return {Promise} - 返回一个Promise，包含最新一次提交信息
 */
export function getCompanyAuthInfo() {
  return axios({
    url: `${BASE_API}/company/auth/info`,
    method: 'get'
  })
}

/**
 * 提交认证
 * @param {Object} data - 提交的数据
 * @return {Promise} - 返回一个Promise，包含提交结果
 */
export function submitCompanyAuth(data) {
  return axios({
    url: `${BASE_API}/company/submit`,
    method: 'post',
    data
  })
}

/**
 * 企业列表，默认获取已认证的企业列表
 * @param {Object} params - 查询参数
 * @return {Promise} - 返回一个Promise，包含企业列表
 */
export function getCompanyList(params) {
  return axios({
    url: `${BASE_API}/company/list`,
    method: 'get',
    params
  })
}

// 企业信息（扩展信息）
export function getCompanyExtraInfo(id) {
  return axios({
    url: `${BASE_API}/company/extra/info`,
    method: 'get',
    params: {
      id
    }
  })
}